// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vkj0","newExpiryDate":"styles_newExpiryDate__V21Oa","footer":"styles_footer__1z_TP"};